// extracted by mini-css-extract-plugin
export default {"content":"RatingsPanel_content__KyGaB","icon":"RatingsPanel_icon__cwDAP","active":"RatingsPanel_active__4r+4s"};